export default __webpack_public_path__ + "static/countryBackground-3307ee90d0abd1dd2ce3b2fe14cab500.png";